module.exports = __webpack_public_path__ + "img/bg-datausing-mobile.5bf02543.jpg";